import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-terms-and-condition',
    templateUrl: './terms-and-condition.component.html',
    styleUrls: ['./terms-and-condition.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsAndConditionComponent implements OnInit {
  comcode: string;
  current: number = 1;
  header: string = "";
  subHeader: string = "";
  classTab: any = ['header-left active', 'header-right']
  constructor(private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {
    this.route.params
            .subscribe(async (params) => {
                this.comcode = params.comcode;
                console.log(this.comcode);
                if (this.comcode == 'mazda') {
                  this.header = "เงื่อนไขการเข้าร่วมโครงการประกันภัยมาสด้าพรีเมี่ยมอินชัวรันส์";
                  this.subHeader = "MAZDA PREMIUM INSURANCE";
                  this.titleService.setTitle('เงื่อนไขการเข้าร่วมโครงการประกันภัยมาสด้าพรีเมี่ยมอินชัวรันส์');
                } else if (this.comcode == 'ford') {
                  this.titleService.setTitle('ข้อกำหนดและเงื่อนไขการเข้าร่วมโครงการประกันภัยฟอร์ดเอนชัวร์');
                  this.header = "ข้อกำหนดและเงื่อนไขการเข้าร่วมโครงการประกันภัยฟอร์ดเอนชัวร์";
                  this.subHeader = "FORD ENSURE";
                } else if (this.comcode == 'nissan') {
                  this.titleService.setTitle('ข้อกำหนดและเงื่อนไขการเข้าร่วมโครงการประกันภัย Nissan Premium Protection');
                  this.header = "ข้อกำหนดและเงื่อนไขการเข้าร่วมโครงการประกันภัย Nissan Premium Protection";
                  this.subHeader = "NISSAN INSURE";
                } else if (this.comcode == 'prim') {
                  this.titleService.setTitle('ข้อกำหนดและเงื่อนไขการเข้าร่วมโครงการประกันภัย Prime Insurance');
                  this.header = "ข้อกำหนดและเงื่อนไขการเข้าร่วมโครงการประกันภัย Prime Insurance";
                  this.subHeader = "PRIME INSURE";
                } else if (this.comcode == 'gwm') {
                  this.titleService.setTitle('ข้อกำหนดและเงื่อนไขการเข้าร่วมโครงการประกันภัย GWM Smart Drive');
                  this.header = "ข้อกำหนดและเงื่อนไขการเข้าร่วมโครงการประกันภัย GWM Smart Drive";
                  this.subHeader = "GWM Smart Drive";
                }
                let index = 0;
                for (let tab_class of this.classTab) {
                  const tab_class_obj = tab_class.split(' ');
                  if (index == 0) {
                    this.classTab[index] = tab_class_obj[0] + ' ' + this.comcode + ' ' + this.comcode + '-active';
                  } else {
                    this.classTab[index] = tab_class_obj[0] + ' ' + this.comcode;
                  }
                  index++;
                }
            });
  }
  clickTab(tab: number) {
    let index = 0;
    for (let tab_class of this.classTab) {
      const tab_class_obj = tab_class.split(' ');
      console.log(tab_class);
      if (index == tab - 1) {
        this.classTab[index] = tab_class_obj[0] + ' ' + tab_class_obj[1] + ' ' + this.comcode + '-active';
      } else {
        this.classTab[index] = tab_class_obj[0] + ' ' + tab_class_obj[1];
      }
      index++;
    }
    this.current = tab;
  }

}
